module.exports = __webpack_public_path__ + "img/kumo_4.9621becd.svg";